export type TRecommendedPackageGift = IRecommendedPackageCashbackGift | IRecommendedPackageVasGift;

export interface IRecommendedPackageCashbackGift {
  /** Тип подарка */
  type: ERecommendedPackageGiftType.Cashback;
  /** Название услуги */
  name: string;
  /** Процент кешбэка */
  cashbackPercent: number;
  /** Кешбэк (баллы на аукцион) */
  auctionPoints: number;
}

export interface IRecommendedPackageVasGift {
  /** Тип подарка */
  type: ERecommendedPackageGiftType.Vas;
  /** Тип услуги */
  serviceType: ERecommendedPackageGiftServiceType;
  /** Название услуги */
  name: string;
  /** Количество размещений на данную услугу */
  count: number;
  /** Срок размещения в днях **/
  durationInDays: number;
}

export enum ERecommendedPackageGiftType {
  Cashback = 'cashback',
  Vas = 'vas',
}

export enum ERecommendedPackageGiftServiceType {
  /** Стандарт */
  Standard = 'standard',
  /** Платная публикация */
  Paid = 'paid',
  /** Премиум публикация */
  Premium = 'premium',
  /** Аукцион */
  Auction = 'auction',
  /** Топ */
  Top3 = 'top3',
  /** Публикация */
  Publication = 'publication',
}
